import pwaConfig from "@/client/applications/saffron/pwaConfig.js";

export default {
  waitForServerConfig: true,
  waitForServerLanguage: true,
  themeColor: pwaConfig.themeColor,
};
